import React from "react";

interface ButtonProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
  disabled?: boolean;
  variant?: "primary" | "secondary" | "transparent";
  className?: string;
  px?: string;
}

export const Button: React.FC<ButtonProps> = ({
  onClick,
  children,
  disabled = false,
  variant = "primary",
  className = "",
  px = "px-4",
}) => {
  const baseStyles = `${px} py-2 rounded-md font-medium transition-colors duration-200`;
  const variantStyles = {
    primary: "bg-[#3490dc] text-white hover:bg-[#2779bd] disabled:bg-[#a0aec0]",
    secondary:
      "bg-gray-200 text-gray-800 hover:bg-gray-300 disabled:bg-gray-100",
    transparent:
      "bg-transparent-200 text-gray-700 hover:bg-gray-300 disabled:bg-gray-100",
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variantStyles[variant]} ${className}`}
    >
      {children}
    </button>
  );
};

interface IBackButtonProps {
  title: string;
  onClick: () => void;
}

export const BackButton: React.FC<IBackButtonProps> = ({ title, onClick }) => {
  return (
    <div className="flex justify-between items-center">
      <div className="flex flex-row items-baseline gap-2">
        <Button
          onClick={onClick}
          className="flex items-center gap-2 mb-4 !text-gray-700 bg-white border border-gray-300 rounded-full p-2 hover:bg-[#fff]"
        >
          <i className="bi bi-chevron-left"></i>
          Back
        </Button>
        <h1 className="text-2xl font-medium text-[#344054]">{title}</h1>
      </div>
    </div>
  );
};

type ButtonGroupProps = {
  buttons: string[];
  onClick: (index: number) => void;
  activeIndex?: number;
  disabled?: boolean;
};

export const ButtonGroup: React.FC<ButtonGroupProps> = ({
  buttons,
  onClick,
  activeIndex,
  disabled = false
}) => {
  return (
    <div className="inline-flex rounded-md">
      {buttons.map((label, index) => (
        <button
        key={label}
        onClick={() => onClick(index)}
        disabled={disabled}
        className={`px-4 py-[0.35rem] text-sm font-medium border border-blue-600 ${
          index === activeIndex
            ? "bg-blue-600 text-white"
            : "bg-white text-gray-700 hover:bg-white"
        } ${index === 0 ? "rounded-l-full border-r" : ""} ${
          index === buttons.length - 1 ? "rounded-r-full rounded-r-full" : "border-r"
        }`}
      >
        {label}
      </button>
      ))}
    </div>
  );
};
